// @ts-strict-ignore
import React from 'react';
import type {
  Control, FieldValues, FieldErrors,
} from 'react-hook-form';

import NumberRangeField from './NumberRangeField';
import DateRangeField from './DateRangeField';

export type AcceptedValuesFieldProps<TFieldValues> = {
  control: Control<TFieldValues>;
  errors: FieldErrors;
  dataType: string;
  disabled?: boolean;
};

const AcceptedValuesField = <TFieldValues extends FieldValues>({
  control, dataType, errors, disabled = false,
}: AcceptedValuesFieldProps<TFieldValues>) => {
  if (dataType === 'integer' || dataType === 'decimal') {
    return (
      <NumberRangeField
        control={control}
        isDecimal={dataType === 'decimal'}
        errors={errors}
        disabled={disabled}
      />
    );
  }

  if (dataType === 'date' || dataType === 'timestamp') {
    return (
      <DateRangeField
        control={control}
        isTimestamp={dataType === 'timestamp'}
        errors={errors}
        disabled={disabled}
      />
    );
  }

  return null;
};

export default AcceptedValuesField;
